import { render, staticRenderFns } from "./SpireBloodMissingResultsDataTable.vue?vue&type=template&id=b1eb5398"
import script from "./SpireBloodMissingResultsDataTable.vue?vue&type=script&lang=js"
export * from "./SpireBloodMissingResultsDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports